'use client';

import ImageView from '@/components/ui/ImageView/ImageView';
import { useEffect, useState } from 'react';
import styles from './LotteryDetailKv.module.scss';

function LotteryDetailKv({
  pcKvUrl,
  spKvUrl,
}: {
  pcKvUrl: string;
  spKvUrl: string;
}) {
  const [isShowSp, setIsShowSp] = useState(false);
  const [isSpkv, setIsSpkv] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const innerWidth = window ? window.innerWidth : 0;
      setIsShowSp(innerWidth < 600);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    setIsSpkv(true);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={styles.componentStyle}>{isSpkv && <ImageView src={isShowSp ? spKvUrl : pcKvUrl} isFreeSize />}</div>
  );
}

export default LotteryDetailKv;
